import React, {
  memo,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Alert,
  ScrollView,
  Dimensions,
} from "react-native";
import CustomText from "../../accessories/CustomText";
import { useDropzone } from "react-dropzone";
import {
  Button,
  DrawerView,
  IconButton,
  InputBox,
  ModalButton,
  Separator,
  Spinner,
  Title,
  context,
} from "../../accessories/accessories";
import {
  generateBoxShadowStyle,
  handleAPI,
  handleSelectLoanProgram,
  log,
} from "../../accessories/CommonFunctions";
import { android, web } from "../../accessories/Platform";
import Dropdown from "../../accessories/DropDown";
import * as DocumentPicker from "expo-document-picker";
import ArrowSpinner from "../../accessories/ArrowSpinner";
import { REDIRECT_URL } from "@env";
import DocumentViewer from "./DocumentViewer";
import ExternalSourceViewer from "../../accessories/ExternalSourceViewer";
import Feather from "react-native-vector-icons/Feather";
import Entypo from "react-native-vector-icons/Entypo";
import FontAwesome from "react-native-vector-icons/FontAwesome";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import * as ImagePicker from "expo-image-picker";
import DocumentScanner from "react-native-document-scanner-plugin";

const DocumentUpload = (props) => {
  const {
    loanData = {},
    setHideProgressBar = () => {},
    userId = 0,
    loanId = 0,
    SessionId = "",
    navigation,
    handleAPIGetLoanDetails = () => {},
    setDocumentViewProps = () => {},
    setPullDownRefresh = () => {},
    documentUploadFlag = {},
  } = props;
  const { setContextDetails } = useContext(context); //Get value from context

  const [processingStatus, setProcessingStatus] = useState(null);
  const [modObjDoc, setModObjDoc] = useState([]);
  const [childWindow, setChildWindow] = useState(null);
  const [jsonObjDoc, setJsonObjDoc] = useState([]);
  const [editDetails, setEditDetails] = useState({ isVisible: !true });
  const [isSaving, setIsSaving] = useState(false);
  const [acceptedFiles, setAcceptedFiles] = useState(null);
  const [iEditUploadDetails, setEditUploadDetails] = useState(null);
  const [uploadIndex, setUploadIndex] = useState(null);
  const [requiredCount, setRequiredCount] = useState(0);
  const [uploadedCount, setUploadedCount] = useState(0);
  const [isAdditionalUploading, setIsAdditionalUploading] = useState(false);
  const [entityTypeList, setEntityTypeList] = useState({
    borrowerEntityTypeList: [2],
    borrowerEmployerEntityTypeList: [6],
    bankEntityTypeList: [7],
    loanEntityTypeList: [1, 17],
  });

  const [errorMessage, setErrorMessage] = useState({
    text: "",
    color: "red",
  });
  // const [DocViewerDetails, setDocViewerDetails] = useState({
  //   isVisible: false,
  // });
  const [SecureDocResult, setSecureDocResult] = useState(null);
  const [borrowerOption, setBorrowerOption] = useState(null);
  const [employerOption, setEmployerOption] = useState(null);
  const [bankOption, setBankOption] = useState(null);
  const [drawerDetails, setDrawerDetails] = useState({
    isShow: false,
    body: <></>,
    onClose: () => {},
  });
  const [additionalBorrowerInfo, setAdditionalBorrowerInfo] = useState([]);
  const [additionalEmploymentInfo, setAdditionalEmploymentInfo] = useState([]);
  const [additionalBankInfo, setAdditionalBankInfo] = useState([]);

  const [activeTab, setActiveTab] = useState(0);

  const renderTab = (title, index) => {
    const isActive = index === activeTab;
    return (
      <TouchableOpacity
        activeOpacity={0.7}
        key={index}
        style={[style.tab, isActive && style.activeTab]}
        onPress={() => setActiveTab(index)}
      >
        <CustomText bold={true} style={[style.tabText]}>
          {title}
        </CustomText>
        <CustomText
          style={{
            backgroundColor: "rgb(184, 208, 233)",
            borderRadius: 4,
            color: "rgb(66, 126, 203)",
            fontSize: 12,
            minWidth: 20,
            overflow: "hidden",
            maxWidth: 20,
            minHeight: web ? 25 : 20,
            display: "flex",
            flex: 1,
            justifyContent: "center",
            alignSelf: "center",
            alignItems: "center",
            textAlign: "center",
          }}
          bold={true}
        >
          {index == 0 ? requiredCount : uploadedCount}
        </CustomText>
      </TouchableOpacity>
    );
  };
  const prePare = () => {
    handleGetOptionDetails();
    //handleGetDetails();
  };
  const handleGetOptionDetails = async () => {
    await handleAPI({
      name: "GetBorEmpBankOptions",
      params: {
        LoanId: loanId,
      },
    })
      .then(async (response) => {
        response = JSON.parse(response);
        handleGetDetails();
        response.forEach((item) => {
          let key = Object.keys(item)[0];
          item[key].forEach((object, index) => {
            object.label = object.label.trim() || key + " " + (index - 1);
            return object;
          });
        });

        setBorrowerOption(response[0]["Borrower"]);
        setAdditionalBorrowerInfo(response[0]["Borrower"].slice(2, 99));
        setEmployerOption(response[1]["Employer"]);
        setAdditionalEmploymentInfo(response[1]["Employer"].slice(2, 99));
        setBankOption(response[2]["Bank"]);
        setAdditionalBankInfo(response[2]["Bank"].slice(2, 99));

        const { EntityList } = response[3];
        setEntityTypeList(() => {
          return {
            borrowerEmployerEntityTypeList: JSON["parse"](
              EntityList[0]["label"]
            ).map((val) => Number(val)),
            borrowerEntityTypeList: JSON["parse"](EntityList[1]["label"]).map(
              (val) => Number(val)
            ),
            bankEntityTypeList: JSON["parse"](EntityList[2]["label"]).map(
              (val) => Number(val)
            ),
            loanEntityTypeList: JSON["parse"](EntityList[3]["label"]).map(
              (val) => Number(val)
            ),
          };
        });
      })
      .catch((err) =>
        console.log("Error from GetBorEmpBankOptions ====> ", err)
      );
  };
  useEffect(() => {
    if (loanId > 0) {
      prePare();
      if (loanData["subjectZip"]) {
        handleSelectLoanProgram(loanId, (loanProductStatus) => {
          setContextDetails((prevContextDetails) => {
            return { ...prevContextDetails, loanProductStatus };
          });
        });
      }
    }
  }, [loanId]);

  useEffect(() => {
    if (props["pullDownRefresh"]) {
      (async () => {
        prePare();
        setPullDownRefresh(false);
      })();
    }
  }, [props["pullDownRefresh"]]);

  const handleGetDetails = async () => {
    let SecureDocResult = await handleGetSecureDoc(),
      SplitSecureResult = SecureDocResult.split("~"),
      jsonObj = JSON.parse(SplitSecureResult[0]),
      jsonObj_ =
        SplitSecureResult[1].length > 0 ? JSON.parse(SplitSecureResult[1]) : [];

    setSecureDocResult(jsonObj);

    setJsonObjDoc([...jsonObj_]);
  };

  const handleResponseFromChild = (event) => {
    const data = event.data;
    if (data && data.value !== undefined) {
      const acceptedFiles = data.value;
      handlePostUpload(acceptedFiles, editDetails);
    }
  };

  useEffect(() => {
    if (web) {
      window?.removeEventListener("message", handleResponseFromChild);
      window.addEventListener("message", handleResponseFromChild);
    }
    return () => {
      if (web) {
        window?.removeEventListener("message", handleResponseFromChild);
      }
    };
  }, [editDetails]);

  useEffect(() => {
    if (modObjDoc.length > 0) {
      const interval = setTimeout(() => {
        if (web) {
          window.dispatchEvent(new Event("resize"));
        }
      }, 1000);
      return () => {
        clearTimeout(interval);
      };
    }
  }, [modObjDoc]);

  useEffect(() => {
    if (borrowerOption && employerOption && bankOption && SecureDocResult) {
      setModObjDoc([...(SecureDocResult || [])]);
    }
  }, [borrowerOption, employerOption, bankOption, SecureDocResult]);

  const handleGetSecureDoc = async () => {
    return await handleAPI({
      name: "GetSecureDoc",
      params: { LoanId: loanId },
    })
      .then((response) => {
        return response;
      })
      .catch((e) => console.error("Error from GetSecureDoc ====> ", e));
  };

  const handleCancelConfirmation = () => {
    Alert.alert(
      "Confirmation",
      "Are you sure you want to Cancel?",
      [
        {
          text: "No",
          style: "cancel",
          onPress: () => {
            setProcessingStatus(null);
          },
        },
        {
          text: "Yes",
          onPress: () => {
            setAcceptedFiles(null);
            setEditDetails({
              ...editDetails,
              isVisible: false,
            });
            setProcessingStatus(null);
          },
        },
      ],
      { cancelable: false }
    );
  };
  const {
    borrowerEmployerEntityTypeList,
    borrowerEntityTypeList,
    bankEntityTypeList,
    loanEntityTypeList,
  } = entityTypeList;

  const DropZone = memo(
    ({ activeTab }) => {
      let jsonObj = [],
        dropZoneElements = [];

      if (modObjDoc.length > 0) jsonObj = modObjDoc;
      // console.clear();
      // console.log({ jsonObj, jsonObjDoc, SessionId });
      for (let i = 0; i < jsonObj.length; i++) {
        let FileUploaded = 0;
        const {
            DocDesc: Message,
            Scandoctype: DocTypeId,
            EntityTypeId: iEntityTypeId,
            SCD: [{ DOCTYPEName: ShortName }],
            EntityName,
            iEntityId,
          } = jsonObj[i],
          iiEntityId = iEntityId || userId;

        const EntityTypeId = Number(iEntityTypeId);
        //         console.log(`
        //   Message       : ${Message}
        //   DocTypeId     : ${DocTypeId}
        //   iEntityTypeId : ${iEntityTypeId}
        //   ShortName     : ${ShortName}
        //   EntityName    : ${EntityName}
        //   iEntityId     : ${iEntityId}
        //   iiEntityId    : ${iiEntityId}
        // `);

        //================================

        let isUploaded = false,
          ScanDocId = "",
          GetJsonFileList = [];

        if (borrowerEmployerEntityTypeList.includes(EntityTypeId)) {
          GetJsonFileList = jsonObjDoc.filter(
            ({
              ScanDocId: fScanDocId,
              Scandoctype,
              iEntityId: fEntityId,
              iRecId: fRecId,
              UseDoc,
            }) =>
              fScanDocId &&
              UseDoc === 2 &&
              Scandoctype === DocTypeId &&
              ([169].includes(Number(DocTypeId)) || [16].includes(EntityTypeId)
                ? fEntityId
                : fRecId) == iEntityId
          );
          GetJsonFileList = jsonObjDoc.filter(
            ({
              ScanDocId: fScanDocId,
              Scandoctype,
              iEntityId: fEntityId,
              iRecId: fRecId,
              UseDoc,
            }) =>
              fScanDocId &&
              UseDoc === 2 &&
              Scandoctype === DocTypeId &&
              ([253].includes(Number(DocTypeId)) || [6].includes(EntityTypeId)
                ? fEntityId
                : fRecId) == iEntityId
          );
        } else if (
          [...borrowerEntityTypeList, ...bankEntityTypeList].includes(
            EntityTypeId
          )
        ) {
          GetJsonFileList = jsonObjDoc.filter(
            ({
              ScanDocId: fScanDocId,
              Scandoctype,
              iEntityId: fEntityId,
              iRecId: fRecId,
              UseDoc,
            }) =>
              fScanDocId &&
              UseDoc === 2 &&
              Scandoctype === DocTypeId &&
              ([772, 373].includes(DocTypeId) ||
              ([88, 62].includes(DocTypeId) && EntityTypeId == 2)
                ? fRecId
                : fEntityId) == iEntityId
          );
        } else if (loanEntityTypeList.includes(EntityTypeId)) {
          GetJsonFileList = jsonObjDoc.filter(
            ({ ScanDocId: fScanDocId, Scandoctype, UseDoc }) =>
              fScanDocId && UseDoc === 2 && Scandoctype === DocTypeId
          );
        }

        if (GetJsonFileList.length > 0) {
          ScanDocId = GetJsonFileList[GetJsonFileList.length - 1]["ScanDocId"];
          isUploaded = true;
          FileUploaded = 1;
        }

        //====================================
        if (ShortName != "Miscellaneous") {
          const icon = (
            <View
              style={[
                {
                  right: 10,
                  alignSelf: web ? "flex-start" : "flex-end",
                  paddingVertical: web ? 0 : 10,
                },
                web ? { top: 15 } : {},
              ]}
            >
              {uploadIndex == i ? (
                <ArrowSpinner
                  isSpinner={true}
                  size={25}
                  color="#295b9a"
                  style={{
                    top: 5,
                    right: -10,
                    position: web ? "absolute" : "relative",
                  }}
                  duration={1200}
                />
              ) : FileUploaded == 1 ? (
                <FontAwesome
                  name="check"
                  size={21}
                  color="green"
                  style={{
                    right: -10,
                    position: web ? "absolute" : "relative",
                  }}
                />
              ) : (
                <>
                  <Feather
                    name="minus"
                    size={30}
                    color="#295b9a"
                    style={{
                      position: "absolute",
                      top: web ? -7 : -10,
                      right: !web ? -36 : -16,
                    }}
                  />
                  <Entypo
                    name="arrow-up"
                    size={18}
                    color="#295b9a"
                    style={{
                      position: "absolute",
                      top: web ? 10 : 5,
                      right: !web ? -30 : -10,
                    }}
                  />
                </>
              )}
            </View>
          );

          const dropZoneProps = {
            Message: `${Message}${
              DocTypeId == 268 || (DocTypeId == 269 && !FileUploaded)
                ? " (Optional)"
                : ""
            }`,
            EntityName,
            icon,
            key: i,
            editUploadDetails: {
              Title: Message,
              isVisible: true,
              EntityName,
              docId: DocTypeId,
              iiEntityId,
              EntityTypeId,
              ientityId:
                GetJsonFileList[GetJsonFileList.length - 1]?.iEntityId ||
                iiEntityId ||
                ([
                  ...borrowerEmployerEntityTypeList,
                  ...bankEntityTypeList,
                ].includes(EntityTypeId)
                  ? iiEntityId
                  : 0) ||
                0,
              iRecId:
                GetJsonFileList[GetJsonFileList.length - 1]?.iRecId ||
                ([
                  ...borrowerEmployerEntityTypeList,
                  ...borrowerEntityTypeList,
                ].includes(EntityTypeId)
                  ? iiEntityId
                  : 0),
              scandocid: ScanDocId || 0,
              index: i,
              isUploaded,
            },
          };

          activeTab === FileUploaded &&
            dropZoneElements.push(
              <View
                key={i}
                style={[
                  {
                    backgroundColor: "#fff",
                    marginBottom: 20,
                    borderRadius: 5,
                    marginRight: 7,
                    marginLeft: 5,
                    minHeight: 50,
                    paddingHorizontal: 10,
                    shadowColor: "rgba(0, 0, 0, 0.30)",
                    shadowRadius: 10,
                    shadowOpacity: 0.5,
                    display: activeTab == 0 && DocTypeId == 269 ? "none" : "",
                  },
                  !web && { flexDirection: "row", alignItems: "center" },
                  generateBoxShadowStyle(2, 3, "black", 0.2, 3, 8, "black"),
                ]}
              >
                {web ? (
                  <DropzoneWeb {...dropZoneProps} />
                ) : (
                  <DropzoneMobile {...dropZoneProps} />
                )}
              </View>
            );
        }
      }

      // if (activeTab == 0) {
      //   setRequiredCount(dropZoneElements.length - 1 || 0);
      //   setUploadedCount(jsonObj.length - dropZoneElements.length || 0);
      // } else {
      //   setUploadedCount(dropZoneElements.length - 1 || 0);
      //   setRequiredCount(jsonObj.length - dropZoneElements.length || 0);
      // }

      // if (activeTab === 0) {
      //   setRequiredCount(
      //     dropZoneElements.length > 1 ? dropZoneElements.length - 1 : 0
      //   );
      //   setUploadedCount(
      //     jsonObj.length - dropZoneElements.length > 0
      //       ? jsonObj.length - dropZoneElements.length
      //       : 0
      //   );
      // } else {
      //   setUploadedCount(
      //     dropZoneElements.length > 1 ? dropZoneElements.length - 1 : 0
      //   );

      //   setRequiredCount(
      //     jsonObj.length - dropZoneElements.length > 0
      //       ? jsonObj.length - dropZoneElements.length
      //       : 0
      //   );d
      // }
      const filteredJsonObjLength = jsonObj.filter(
        (doc) => doc.Scandoctype === 269
      ).length;

      if (activeTab == 0) {
        setRequiredCount(
          dropZoneElements.length - filteredJsonObjLength > 0
            ? dropZoneElements.length - filteredJsonObjLength
            : 0
        );
        setUploadedCount(
          jsonObj.length - dropZoneElements.length > 0
            ? jsonObj.length - dropZoneElements.length
            : 0
        );
      } else {
        setRequiredCount(
          jsonObj.length - dropZoneElements.length - filteredJsonObjLength > 0
            ? jsonObj.length - dropZoneElements.length - filteredJsonObjLength
            : 0
        );
        setUploadedCount(dropZoneElements.length || 0);
      }

      return dropZoneElements.length ? (
        dropZoneElements
      ) : (
        <View
          style={[
            {
              backgroundColor: "#fff",
              marginBottom: 20,
              borderRadius: 5,
              marginRight: 7,
              marginLeft: 5,
              minHeight: 50,
              paddingHorizontal: 10,
              marginTop: 15,
              textAlign: "center",
            },
            !web && { flexDirection: "row", alignItems: "center" },
          ]}
        >
          <CustomText
            style={{ textAlign: "left", justifyContent: "flex-start" }}
          >
            {activeTab == 0
              ? `Congratulations! All of your required documents are uploaded.
                
You can review your uploaded documents by clicking the "Uploaded" tab above.  

 As your loan steps progress, there may be more documents to upload. We will let you know if another document needs to be uploaded.`
              : `There aren't any uploaded documents yet... 

                You can upload your documents by clicking the "Required Documents" tab above.`}
          </CustomText>
        </View>
      );
    },
    [modObjDoc]
  );

  const GetEditScreen = ({ iUploadDetails }) => {
    let { docId, ientityId, EntityTypeId } = editDetails || iUploadDetails,
      employerValue = 0;

    if (bankEntityTypeList.includes(EntityTypeId)) {
      employerValue =
        ientityId > 0
          ? ientityId
          : additionalEmploymentInfo.length === 0
          ? 1
          : null;
    } else {
      employerValue =
        ientityId > 0 && docId !== 169
          ? ientityId
          : additionalEmploymentInfo.length === 0
          ? 1
          : null;
    }
    // if (
    //   (bankEntityTypeList.includes(EntityTypeId)
    //     ? bankOption
    //     : employerOption
    //   ).filter((item) => item.value == ientityId).length == 0
    // ) {
    //   ientityId = -99;
    // }

    return (
      <View
        style={{
          maxHeight: Dimensions.get("screen").height / 1.4,
          minHeight: Dimensions.get("screen").height / 1.4,
        }}
      >
        {[
          ...borrowerEmployerEntityTypeList,
          ...borrowerEntityTypeList,
        ].includes(EntityTypeId) && (
          <View>
            <Title
              text="Which borrower is this for?"
              style={{ marginBottom: 15 }}
            />
            <Dropdown
              isValid={true}
              label="Borrower"
              options={borrowerOption}
              value={editDetails["iRecId"]}
              onSelect={(item) => {
                setEditDetails({
                  ...editDetails,
                  iRecId: parseInt(item["value"]),
                });
              }}
              isMap={true}
              // disabled={docId == 772 || docId == 213 || docId == 253}
            />

            {editDetails["iRecId"] === 1 && (
              <>
                <InputBox
                  validate={!(editDetails["firstName"] || "")}
                  label="First Name"
                  placeholder="First Name"
                  onChangeText={(text) => {
                    setEditDetails({ ...editDetails, firstName: text });
                  }}
                  value={(editDetails["firstName"] || "")?.toString()}
                />
                <InputBox
                  validate={!(editDetails["lastName"] || "")}
                  label="Last Name"
                  placeholder="Last Name"
                  onChangeText={(text) => {
                    setEditDetails({ ...editDetails, lastName: text });
                  }}
                  value={(editDetails["lastName"] || "")?.toString()}
                />
              </>
            )}
          </View>
        )}
        {bankEntityTypeList.includes(EntityTypeId) && (
          <>
            <View>
              <Title
                text={`Which bank is this for?`}
                style={{ marginBottom: 15, marginTop: 15 }}
              />
              <Dropdown
                isValid={true}
                label="Bank"
                options={bankOption}
                value={ientityId}
                onSelect={(item) => {
                  setEditDetails({
                    ...editDetails,
                    ientityId: item["value"],
                  });
                }}
                isMap={true}
                // disabled={docId == 43}
              />
              {editDetails["ientityId"] === 1 && (
                <InputBox
                  validate={!(editDetails["BankName"] || "")}
                  label="Bank Name"
                  placeholder="Bank Name"
                  onChangeText={(text) => {
                    setEditDetails({ ...editDetails, BankName: text });
                  }}
                  value={(editDetails["BankName"] || "")?.toString()}
                />
              )}
            </View>
          </>
        )}
        {borrowerEmployerEntityTypeList.includes(EntityTypeId) && (
          <>
            <View>
              <Title
                text={`Which Employer is this for?`}
                style={{ marginBottom: 15, marginTop: 15 }}
              />
              <Dropdown
                isValid={true}
                label="Employer"
                options={employerOption}
                value={editDetails["ientityId"]}
                onSelect={(item) => {
                  setEditDetails({
                    ...editDetails,
                    ientityId: parseInt(item["value"]),
                  });
                }}
                isMap={true}
              />
              {editDetails["ientityId"] === 1 && (
                <InputBox
                  validate={!(editDetails["employerName"] || "")}
                  label="Employer Name"
                  placeholder="Employer Name"
                  onChangeText={(text) => {
                    try {
                      setEditDetails({ ...editDetails, employerName: text });
                    } catch (e) {
                      log("Error from  ====> ", e);
                    }
                  }}
                  value={(editDetails["employerName"] || "")?.toString()}
                />
              )}
            </View>
          </>
        )}

        <View
          style={{
            flexDirection: "row",
            alignSelf:
              processingStatus === "cancelConfirmation"
                ? "flex-start"
                : "flex-end",
          }}
        >
          {isSaving && (
            <View style={{ flexDirection: "row" }}>
              <ArrowSpinner
                style={{ height: 22, alignSelf: "flex-end" }}
                size={20}
              />
              <CustomText style={{ fontSize: 14, alignSelf: "flex-end" }}>
                {" "}
                File is Uploading...{"  "}
              </CustomText>
            </View>
          )}
          {processingStatus === "cancelConfirmation" && web && (
            <View style={{ flexDirection: "column" }}>
              <View>
                <Title
                  style={{ fontSize: web ? 22 : 18 }}
                  text="Are you sure you want to Cancel?"
                />
              </View>
              <View style={{ flexDirection: "row" }}>
                <IconButton
                  buttonType="secondary"
                  title="No"
                  onPress={async () => {
                    setProcessingStatus(null);
                  }}
                  style={{ marginRight: 15 }}
                />
                <IconButton
                  title="Yes"
                  onPress={async () => {
                    setAcceptedFiles(null);
                    setEditDetails({ ...editDetails, isVisible: false });
                    setProcessingStatus(null);
                  }}
                  style={{ marginRight: 5 }}
                />
              </View>
            </View>
          )}
          {(processingStatus !== "cancelConfirmation" || !web) && (
            <View style={{ flexDirection: "row", height: 43 }}>
              <IconButton
                buttonType="secondary"
                style={{
                  marginRight: 15,
                }}
                title="Cancel"
                onPress={async () => {
                  if ((acceptedFiles || []).length) {
                    setProcessingStatus("cancelConfirmation");

                    handleCancelConfirmation();
                  } else {
                    setEditDetails({ ...editDetails, isVisible: false });

                    setUploadIndex(null);
                  }
                }}
              />

              <IconButton
                title={<>Save</>}
                onPress={() => {
                  setIsSaving(true);
                  handleSaveEditDetails();
                  setProcessingStatus(null);
                }}
              />
            </View>
          )}
        </View>
        <Separator />
        <Separator />
      </View>
    );
  };

  const handleSaveAdditionalInfo = async (
    flag,
    InputJSON,
    CustId = 0,
    type
  ) => {
    return await handleAPI({
      name: "SaveAdditionalInfo",
      params: {
        CustId,
        LoanId: loanId,
        InputJSON: JSON.stringify(InputJSON || {}),
        flag: flag,
        SessionId: SessionId,
      },
    })
      .then((CustId) => {
        handleAPIGetLoanDetails();
        CustId = Number(CustId);
        handleGetOptionDetails();
        let key = "iRecId";

        if (type === "Borrower") {
          key = "iRecId";
          const { FirstName, LastName } = InputJSON[0],
            option = {
              value: CustId,
              label: `${FirstName} ${LastName}`,
            };
          setBorrowerOption((prevBorrowerOption) => {
            return [...prevBorrowerOption, option];
          });
        } else if (type === "Employer") {
          key = "ientityId";
          const { Empmt_Emp_Name } = InputJSON[0],
            option = {
              value: CustId,
              label: Empmt_Emp_Name,
            };
          setEmployerOption((prevEmployerOption) => {
            return [...prevEmployerOption, option];
          });
        } else if (type === "Bank") {
          key = "ientityId";
          const { Bank_Name } = InputJSON[0],
            option = {
              value: CustId,
              label: Bank_Name,
            };
          setBankOption((prevBankOption) => {
            return [...prevBankOption, option];
          });
        }
        setEditDetails({
          ...editDetails,
          [key]: parseInt(CustId),
        });
        return CustId;
      })
      .catch((e) => console.error("Error from SaveAdditionalInfo ====>", e));
  };

  const handleSaveEditDetails = async (acceptedFiles, iUploadDetails) => {
    let {
      docId,
      ientityId,
      iRecId,
      firstName,
      lastName,
      employerName,
      EntityTypeId,
      BankName,
    } = iUploadDetails || editDetails;

    // if (
    //   (bankEntityTypeList.includes(EntityTypeId)
    //     ? bankOption
    //     : employerOption
    //   ).filter((item) => item.value == ientityId).length == 0
    // ) {
    //   ientityId = -99;
    // }

    if (borrowerEmployerEntityTypeList.includes(EntityTypeId)) {
      let WhichBorrower = loanData["UserId"],
        WhichEntity = loanData["Employer_name"];

      if (iRecId) {
        WhichBorrower =
          iRecId > 1
            ? iRecId
            : await handleSaveAdditionalInfo(
                -99,
                [
                  {
                    FirstName: firstName || "Borrower First",
                    LastName: lastName || "Borrower Last",
                  },
                ],
                0,
                "Borrower"
              );
      }

      WhichEntity =
        ientityId > 1
          ? ientityId
          : await handleSaveAdditionalInfo(
              -11,
              [{ Empmt_Emp_Name: employerName || "Employer" }],
              WhichBorrower,
              "Employer"
            );
      // if (EntityTypeId == 6)
      //   WhichEntity = loanData["EmployerId"] || WhichEntity;
      handleSaveUploadedFiles(
        WhichEntity,
        WhichBorrower,
        docId,
        acceptedFiles,
        iUploadDetails
      );
    }

    if (bankEntityTypeList.includes(EntityTypeId)) {
      let WhichBorrower = loanData["UserId"],
        WhichEntity = 0;

      if (iRecId) {
        WhichBorrower =
          iRecId > 1
            ? iRecId
            : await handleSaveAdditionalInfo(
                -99,
                [
                  {
                    FirstName: firstName || "Borrower First",
                    LastName: lastName || "Borrower Last",
                  },
                ],
                0,
                "Borrower"
              );
      }

      WhichEntity =
        ientityId > 1
          ? ientityId
          : await handleSaveAdditionalInfo(
              -33,
              [{ Bank_Name: BankName || "Bank", AccType: 0 }],
              WhichBorrower,
              "Bank"
            );

      handleSaveUploadedFiles(
        WhichEntity,
        WhichBorrower,
        docId,
        acceptedFiles,
        iUploadDetails
      );
    }

    if (
      docId === 269 ||
      [...borrowerEntityTypeList, ...loanEntityTypeList].includes(EntityTypeId)
    ) {
      let WhichBorrower = loanData["UserId"],
        WhichEntity = 0;
      if (docId === 269) {
        WhichBorrower = loanData["UserId"] || userId;
        WhichEntity = 0;
      } else if (iRecId) {
        WhichBorrower =
          iRecId > 1
            ? iRecId
            : await handleSaveAdditionalInfo(
                -99,
                [
                  {
                    FirstName: firstName || "Borrower First",
                    LastName: lastName || "Borrower Last",
                  },
                ],
                0,
                "Borrower"
              );
        if (EntityTypeId == 2) WhichEntity = ientityId;
      }
      handleSaveUploadedFiles(
        WhichEntity,
        WhichBorrower,
        docId,
        acceptedFiles,
        iUploadDetails
      );
    }
  };

  const handleSaveScanDocDetails = (
    scandocid,
    ientityid,
    EntityTypeId,
    irecid,
    loadFlag
  ) => {
    let xml = `<root><row><scandocid>${scandocid}</scandocid><ientityid>${ientityid}</ientityid><irecid>${irecid}</irecid><ientitytypeid>${EntityTypeId}</ientitytypeid></row></root>`;
    handleAPI({
      name: "savescandocdetails",
      params: { loanid: loanId, xml: xml },
    })
      .then(async () => {
        if (loadFlag) {
          setIsSaving(false);

          let SecureDocResult = await handleGetSecureDoc();

          let SplitSecureResult = SecureDocResult.split("~"),
            jsonObj = JSON.parse(SplitSecureResult[0]),
            jsonObj_ =
              SplitSecureResult[1].length > 0
                ? JSON.parse(SplitSecureResult[1])
                : [];

          setModObjDoc(jsonObj || []);
          //setModObjDoc(handleGetModObjDoc(jsonObj) || []);
          setJsonObjDoc([...[], ...jsonObj_]);

          //Go Back to upload window
          setEditDetails({ ...{}, isVisible: false });

          setUploadIndex(null);
          setAcceptedFiles(null);
          setIsAdditionalUploading(false);
        }
        if (uploadIndex == -99) {
          handleToggleDrawer(false, false);
        }
        if (web) {
          childWindow?.document?.getElementById("buttonReloadDoc")?.click();
          window?.opener?.document?.getElementById("buttonReloadDoc")?.click();
        }
      })
      .catch((e) => {
        setIsSaving(false);
        console.error("Error from savescandocdetails ====> ", e);
      });
  };
  const handleToggleDrawer = async (isShow, isReload) => {
    if (isReload) {
      prePare();
    }

    setDrawerDetails((prevDrawerDetails) => {
      return {
        ...prevDrawerDetails,
        isShow: isShow,
      };
    });
  };

  const handleOpenFile = async (iEditUploadDetails, acceptedFiles = []) => {
    const { ScanDocId, docId, ientityId, iiEntityId, EntityTypeId } =
      iEditUploadDetails;

    if (web) {
      setDocumentViewProps({
        ...{
          iEntityId: ientityId,
          EntityTypeId,
          iiEntityId: iiEntityId,
          doctype: docId,
          SessionId,
          Title: iEditUploadDetails["Title"],
          LoanId: loanId,
          ScanDocId: ScanDocId,
          isVisible: true,
          navigation: navigation,
          iEditUploadDetails,
          documentArray: jsonObjDoc,
          iAcceptedFiles: acceptedFiles,
          handleToggleDrawer: handleToggleDrawer,
          handleSelectFileDocView: () => {
            setEditUploadDetails(iEditUploadDetails);
            handleFilePickOption(iEditUploadDetails);
          },
        },
      });
    } else {
      setContextDetails((prevContextDetails) => {
        return {
          ...prevContextDetails,
          cacheDocDetails: null,
        };
      });

      // setDocViewerDetails({
      //   isVisible: true,
      //   SessionId,
      //   Id: ScanDocId,
      //   doctype: docId,
      //   LoanId: loanId,
      //   iEntityId: ientityId,
      //   iiEntityId: iiEntityId,
      //   entityTypeId: EntityTypeId,
      // });
      setHideProgressBar(true);
      setDrawerDetails({
        ...drawerDetails,
        ...{
          body: (
            <>
              <DocumentViewer
                iEntityId={ientityId}
                iiEntityId={iiEntityId}
                EntityTypeId={EntityTypeId}
                doctype={docId}
                SessionId={SessionId}
                Title={iEditUploadDetails["Title"]}
                LoanId={loanId}
                ScanDocId={ScanDocId}
                navigation={navigation}
                documentArray={jsonObjDoc}
                handleToggleDrawer={handleToggleDrawer}
                handleSelectFileDocView={() => {
                  setEditUploadDetails(iEditUploadDetails);
                  handleFilePickOption(iEditUploadDetails);
                }}
              />
            </>
          ),
          isShow: true,
          onClose: () => {
            setDrawerDetails({
              isShow: false,
              body: <></>,
              onClose: () => {},
            });
          },
        },
      });
    }
  };

  const scanDocument = async (isPickFile) => {
    try {
      if (!web) {
        const { status } = await ImagePicker.requestCameraPermissionsAsync();

        let result;
        if (status !== "granted") {
          console.error("Sorry, we need camera permissions to make this work!");
        } else {
          if (isPickFile) {
            try {
              result = await ImagePicker.launchImageLibraryAsync({
                mediaTypes: ImagePicker.MediaTypeOptions.Images,
                allowsEditing: true,
                quality: 1,
              });
            } catch (error) {
              console.error(
                "Error form ImagePicker.launchImageLibraryAsync ===> ",
                error
              );
            }
            result = result["assets"];
          } else {
            try {
              const { scannedImages } = await DocumentScanner.scanDocument({
                maxNumDocuments: 1,
              });

              if (scannedImages?.length > 0) {
                result = scannedImages.map((uri) => ({
                  uri: uri,
                }));
              }
            } catch (error) {
              Alert.alert("Error form DocumentScanner", error.message);
            }
          }
        }
        return result;
      }
    } catch (error) {
      Alert.alert("Error form requestCameraPermissionsAsync", error.message);
      return null;
    }
  };

  const handleSaveUploadedFiles = (
    iEntityId,
    iRecId,
    DocTypeId,
    iAcceptedFiles,
    iEditDetails
  ) => {
    // let editDetails_ =   {...iEditDetails ,...editDetails},
    let editDetails_ = iEditDetails || editDetails,
      acceptedFiles_ = iAcceptedFiles || acceptedFiles,
      details = {
        LoanId: loanId,
        sessionid: SessionId,
        DocTypeId,
        entityid: iEntityId || editDetails_["ientityId"] || 0,
        iRecId: iRecId || editDetails_["iRecId"] || 0,
        Category: editDetails_["Category"] || 0,
        description: editDetails_["Descript"] || "",
        usedoc: editDetails_["UseDoc"] || 2,
        entitytypeid: editDetails_["EntityTypeId"] || 0,
        conditonid: 0,
      },
      index = 1;

    if (acceptedFiles_) {
      acceptedFiles_.forEach(async (file) => {
        let formData = new FormData();
        if (web) formData.append("", file);
        else {
          let randomString = require("randomstring"),
            GuiId = randomString.generate(5),
            fileName = `$ScannedImage_${GuiId}.jpg`;

          formData.append("file_attachment", {
            uri: file.uri,
            name: file.name || fileName || "ScannedImage.jpg",
            type: file.mimeType || "image/jpg",
          });
        }
        let requestOptions = {
          method: "POST",
          body: formData,
          redirect: "follow",
        };

        await handleAPI({
          name: "UploadFilesdocs",
          params: details || {},
          requestOptions: requestOptions,
        })
          .then((ScanDocId) => {
            log("Response form UploadFilesdocs ====> ", ScanDocId);
            if (ScanDocId)
              handleSaveScanDocDetails(
                ScanDocId,
                iEntityId,
                editDetails_["EntityTypeId"],
                editDetails_["iRecId"] || iRecId || 0,
                index === acceptedFiles_.length
              );

            index++;
          })
          .catch((e) => console.error("Error form UploadFilesdocs ====> ", e));
      });
    } else {
      handleSaveScanDocDetails(
        editDetails_["scandocid"],
        iEntityId,
        editDetails_["EntityTypeId"],
        editDetails_["iRecId"] || iRecId || 0,
        true
      );
    }
  };

  const handlePostUpload = (acceptedFiles, UploadDetails) => {
    let iUploadDetails = UploadDetails || iEditUploadDetails;

    const { EntityTypeId } = iUploadDetails;

    let DocTypeId = Number(iUploadDetails["docId"]),
      WhichEntity =
        iUploadDetails["ientityId"] || iUploadDetails["iiEntityId"] || 0;

    if (
      DocTypeId === 269 ||
      (borrowerEntityTypeList.includes(EntityTypeId) &&
        borrowerOption.length >= 3) ||
      (bankEntityTypeList.includes(EntityTypeId) && bankOption.length >= 3) ||
      (borrowerEmployerEntityTypeList.includes(EntityTypeId) &&
        borrowerOption.length >= 3 &&
        employerOption.length >= 3) ||
      loanEntityTypeList.includes(EntityTypeId)
    ) {
      // if (
      //   bankEntityTypeList.includes(EntityTypeId) &&
      //   !WhichEntity &&
      //   bankOption.length >= 3
      // ) {
      if (bankEntityTypeList.includes(EntityTypeId) && bankOption.length >= 3) {
        if (!WhichEntity) WhichEntity = bankOption[1]["value"];

        setEditDetails({
          ...iUploadDetails,
          ientityId: WhichEntity,
        });
      }
      if (
        borrowerEmployerEntityTypeList.includes(EntityTypeId) &&
        employerOption.length >= 3
      ) {
        if (!WhichEntity) WhichEntity = employerOption[1]["value"];

        setEditDetails({
          ...iUploadDetails,
          ientityId: WhichEntity,
        });
        setEditDetails({
          ...iUploadDetails,
          iRecId: loanData["UserId"],
        });
      }

      handleSaveEditDetails(acceptedFiles, iUploadDetails);
      setUploadIndex(iUploadDetails["index"]);

      setDrawerDetails({
        isShow: false,
        body: <></>,
        onClose: () => {},
      });
    } else {
      setUploadIndex(-99);
      if (Object.keys(iUploadDetails)?.length > 0) {
        setEditDetails({ ...iUploadDetails });
        handleToggleDrawer(true, false);
      }
      setAcceptedFiles(acceptedFiles);
    }
  };
  const allowedExtensions = [
    ".jpg",
    ".jpeg",
    ".png",
    ".gif",
    ".tif",
    ".tiff",
    ".pdf",
    ".heic",
    ".heif",
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
  ];

  const validateFileType = (fileName) => {
    if (!fileName) return false;
    const fileExtension = fileName
      .toLowerCase()
      .substring(fileName.lastIndexOf("."));
    return allowedExtensions.includes(fileExtension);
  };

  const validateFiles = (files) => {
    const invalidFiles = [];
    const validFiles = [];

    files.forEach((file) => {
      const fileName = file.name || file.uri || "";
      if (validateFileType(fileName)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(fileName);
      }
    });

    if (invalidFiles.length > 0) {
      setErrorMessage({
        text: (
          <CustomText style={{ color: "red", fontSize: 12 }}>
            {
              ("Invalid File Type",
              `The following files are not supported:\n${invalidFiles.join(
                "\n"
              )}\n\n` +
                `Allowed types: ${allowedExtensions
                  .map((ext) => ext.replace(".", "").toUpperCase())
                  .join(", ")}`)
            }
          </CustomText>
        ),
        color: "red",
      });
    }

    return validFiles;
  };
  const DropzoneWeb = ({
    Message,
    EntityName,
    icon,
    editUploadDetails = {},
  }) => {
    const onDrop = useCallback((acceptedFiles) => {
      setErrorMessage({
        text: "",
        color: "red",
      });

      const validFiles = validateFiles(acceptedFiles);
      if (validFiles.length === 0) return;

      const { EntityTypeId } = editUploadDetails,
        isDirectSave =
          (borrowerEntityTypeList.includes(EntityTypeId) &&
            borrowerOption.length >= 3) ||
          (bankEntityTypeList.includes(EntityTypeId) &&
            bankOption.length >= 3) ||
          (borrowerEmployerEntityTypeList.includes(EntityTypeId) &&
            employerOption.length >= 3) ||
          loanEntityTypeList.includes(EntityTypeId);

      if (isDirectSave) handlePostUpload(acceptedFiles, editUploadDetails);
      else handleOpenFile(editUploadDetails, acceptedFiles);
    }, []);

    let userAgent = navigator.userAgent,
      isFireFox = userAgent.indexOf("Firefox") !== -1,
      isSafari = userAgent.indexOf("Safari") !== -1;

    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    const getFile = () => {
      const input = document.createElement("input");
      input.type = "file";

      input.addEventListener("change", async (event) => {
        const files = Array.from(event.target.files);
        if (files) {
          onDrop(files);
        }
      });
      input.click();
    };

    return (
      <TouchableOpacity
        activeOpacity={0.5}
        style={[style.dropContainer]}
        key={props["key"]}
        onPress={() => {
          setEditDetails({ ...editUploadDetails });
        }}
      >
        <div
          {...(editUploadDetails["isUploaded"]
            ? {
                onClick: () => handleOpenFile(editUploadDetails),
              }
            : isFireFox
            ? {
                ...getRootProps(),
                onClick: () => getFile(),
              }
            : isSafari
            ? {
                ...getRootProps(),
                onClick: () => getFile(),
                onTouchStart: () => getFile(),
              }
            : getRootProps())}
          style={{
            //height: 55,
            minHeight: 55,
            flexDirection: "row",
            justifyContent: "space-between",
            display: "flex",
          }}
        >
          {!editUploadDetails["isUploaded"] && <input {...getInputProps()} />}
          <View
            style={{
              width: "80%",
            }}
          >
            <CustomText
              style={{
                fontSize: 13,
                minHeight: EntityName === "" ? 40 : 25,
                cursor: "pointer",
                display: "grid",
                alignContent: "center",
                fontWeight: "bold",
                paddingVertical: 0,
              }}
            >
              {Message}
            </CustomText>
            <CustomText
              style={{
                fontSize: 13,
                cursor: "pointer",
                display: "grid",
                alignContent: "center",
              }}
            >
              {EntityName}
            </CustomText>
          </View>
          {icon}
        </div>
      </TouchableOpacity>
    );
  };

  const handleFilePickOption = (editUploadDetails) => {
    setDrawerDetails({
      body: (
        <View style={{ flex: 1 }}>
          <CustomText
            style={{ fontSize: web ? 22 : 20, alignSelf: "center" }}
            bold={true}
          >
            {editUploadDetails["Title"]}
          </CustomText>
          <CustomText style={{ fontSize: web ? 16 : 14, alignSelf: "center" }}>
            {editUploadDetails["EntityName"]}
          </CustomText>

          <Separator />
          <ModalButton
            icon={
              <View style={{ marginBottom: -1 }}>
                <MaterialIcons name="insert-photo" color="#fff" size={14} />
              </View>
            }
            onPress={() => {
              handleSelectFile(true, editUploadDetails, true);
            }}
            title="  Select Photo"
            textStyle={{
              alignSelf: "center",
              color: "#fff",
              fontSize: 13,
            }}
            style={{
              borderRadius: 25,
              marginBottom: 10,
              backgroundColor: "#295B9A",
              height: 45,
            }}
          />
          <ModalButton
            onPress={() => {
              handleSelectFile(true, editUploadDetails);
            }}
            title="  Take Photo"
            icon={
              <View style={{ marginBottom: 0 }}>
                <MaterialIcons name="add-a-photo" color="#295b9a" size={14} />
              </View>
            }
            textStyle={{
              alignSelf: "center",
              color: "#295b9a",
              fontSize: 13,
            }}
            style={{
              borderRadius: 25,
              marginBottom: 10,
              backgroundColor: "#fff",
              borderWidth: 1,
              borderColor: "#295b9a",
              height: 45,
            }}
          />

          <ModalButton
            icon={
              <View style={{ marginBottom: -1 }}>
                <MaterialIcons name="photo-library" color="#295b9a" size={14} />
              </View>
            }
            onPress={() => {
              handleSelectFile(false, editUploadDetails);
            }}
            title="  Add From Library"
            textStyle={{ alignSelf: "center", fontSize: 13, color: "#295b9a" }}
            style={{
              borderRadius: 25,
              height: 45,
              marginBottom: 10,
              backgroundColor: "#fff",
              borderWidth: 1,
              borderColor: "#295b9a",
            }}
          />
          {editUploadDetails["isUploaded"] && (
            <ModalButton
              icon={
                <View style={{ marginBottom: -1 }}>
                  <MaterialCommunityIcons
                    name="file-document-multiple"
                    color="#295b9a"
                    size={14}
                  />
                </View>
              }
              onPress={() => handleOpenFile(editUploadDetails)}
              title="  View Uploaded Documents"
              textStyle={{
                alignSelf: "center",
                fontSize: 13,
                color: "#295b9a",
              }}
              style={{
                borderRadius: 25,
                marginBottom: 10,
                backgroundColor: "#fff",
                borderWidth: 1,
                borderColor: "#295b9a",
                height: 45,
              }}
            />
          )}

          <Separator />
          <Separator />
        </View>
      ),
      isShow: true,
      onClose: "CustomClose",
    });
  };

  const handleSelectFile = async (isScan, editUploadDetails, isPickFile) => {
    try {
      if (isScan) {
        let scannedImage = await scanDocument(isPickFile);
        scannedImage && handlePostUpload(scannedImage, editUploadDetails);
      } else {
        setErrorMessage({
          text: "",
          color: "red",
        });
        try {
          const result = await DocumentPicker.getDocumentAsync({
            copyToCacheDirectory: false,
            type: [
              "application/pdf",
              "image/jpeg",
              "image/png",
              "image/gif",
              "image/heic",
              "image/heif",
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              "application/vnd.ms-excel", // for .xls
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // for .xlsx
            ],
          });

          if (result["type"] === "success") {
            const allowedExtensions = [
              "pdf",
              "jpg",
              "jpeg",
              "png",
              "gif",
              "heic",
              "heif",
              "doc",
              "docx",
              "xls",
              "xlsx",
            ];
            const fileExtension = result.name.split(".").pop().toLowerCase();

            const validFiles = validateFiles(file);
            if (validFiles.length === 0) {
              return;
            }
            if (allowedExtensions.includes(fileExtension)) {
              let file = [];
              file.push(result);
              handlePostUpload(file, editUploadDetails);
            } else {
              //             Alert.alert(
              //               "Unsupported File Type",
              //               `We do not accept .${fileExtension} files. Please upload PDF, Word documents
              // (DOC/DOCX), or image files (JPG, JPEG, PNG, GIF, HEIC, HEIF).`
              //             );
              setErrorMessage({
                text: (
                  <CustomText style={{ color: "red", fontSize: 12 }}>
                    {
                      ("Invalid File Type",
                      `The following files are not supported:\n${invalidFiles.join(
                        "\n"
                      )}\n\n` +
                        `Allowed types: ${allowedExtensions
                          .map((ext) => ext.replace(".", "").toUpperCase())
                          .join(", ")}`)
                    }
                  </CustomText>
                ),
                color: "red",
              });
            }
            // else {
            //   Alert.alert(
            //     "Invalid File",
            //     "Please select a valid PDF or image file."
            //   );

            // }
          }
        } catch (error) {
          console.error("Error From FileUpload ====> ", error);
        }
      }
    } catch (err) {
      console.warn(err);
      return false;
    }
  };

  const DropzoneMobile = ({
    editUploadDetails = {},
    Message = "",
    EntityName = "",
    icon = <></>,
  }) => {
    return (
      <TouchableOpacity
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          flex: 1,
        }}
        activeOpacity={1}
        key={props["key"]}
        onPress={() => {
          //  log("DocId", editUploadDetails["docId"]);

          setEditUploadDetails({
            ...{ ...editUploadDetails, isVisible: true },
          });
          if (editUploadDetails["isUploaded"])
            handleOpenFile(editUploadDetails);
          else handleFilePickOption(editUploadDetails);
        }}
      >
        <View
          style={{
            width: "90%",
            alignSelf: "center",
          }}
        >
          <CustomText style={[{ fontSize: web ? 13 : 11 }]} bold={true}>
            {Message}
          </CustomText>
          <CustomText
            style={{
              fontSize: web ? 13 : 11,
              paddingVertical: 5,
            }}
          >
            {EntityName}
          </CustomText>
        </View>
        <View
          style={{
            width: "10%",
            alignSelf: "center",
          }}
        >
          <CustomText>{icon}</CustomText>
        </View>
      </TouchableOpacity>
    );
  };

  const findDocType269 = () => {
    if (modObjDoc.length > 0) {
      const docType269 = modObjDoc.find((doc) => doc.Scandoctype === 269);
      if (docType269) {
        const {
          DocDesc: Message,
          Scandoctype: DocTypeId,
          EntityTypeId: iEntityTypeId,
          SCD: [{ DOCTYPEName: ShortName }],
          EntityName,
          iEntityId,
        } = docType269;

        const iiEntityId = iEntityId || userId;
        const EntityTypeId = Number(iEntityTypeId);

        // Check if already uploaded
        let GetJsonFileList = [];
        if (loanEntityTypeList.includes(EntityTypeId)) {
          GetJsonFileList = jsonObjDoc.filter(
            ({ ScanDocId: fScanDocId, Scandoctype, UseDoc }) =>
              fScanDocId && UseDoc === 2 && Scandoctype === DocTypeId
          );
        }

        const isUploaded = GetJsonFileList.length > 0;
        const ScanDocId = isUploaded
          ? GetJsonFileList[GetJsonFileList.length - 1]["ScanDocId"]
          : "";

        return {
          Title: Message,
          isVisible: true,
          EntityName,
          docId: DocTypeId,
          iiEntityId,
          EntityTypeId,
          ientityId:
            GetJsonFileList[GetJsonFileList.length - 1]?.iEntityId ||
            iiEntityId ||
            0,
          iRecId: GetJsonFileList[GetJsonFileList.length - 1]?.iRecId || 0,
          scandocid: ScanDocId || 0,
          index: -1,
          isUploaded,
        };
      }
    }
    return null;
  };

  const handleDirectAdditionalUpload = () => {
    const docType269Details = findDocType269();

    if (!docType269Details) {
      console.warn("DocTypeId 269 not found in document list");
      return;
    }

    // Force direct upload mode - ignore isUploaded status
    const uploadDetails = {
      ...docType269Details,
      isUploaded: false, // Force to false to bypass drawer
    };

    if (web) {
      const input = document.createElement("input");
      input.type = "file";
      input.multiple = true;
      // input.accept =
      //   "application/pdf,image/jpeg,image/png,image/gif,image/heic,image/heif";
      input.accept = [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/heic",
        "image/heif",
        "application/msword", // .doc
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
        "application/vnd.ms-excel", // .xls
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      ].join(",");

      input.addEventListener("change", async (event) => {
        const files = Array.from(event.target.files);
        if (files && files.length > 0) {
          // Always use direct upload flow - skip drawer
          const validFiles = validateFiles(files);
          if (validFiles.length > 0) {
            setIsAdditionalUploading(true);
            handlePostUpload(files, uploadDetails);
          }
        }
      });
      input.click();
    } else {
      // For mobile - directly trigger file picker options, skip drawer
      setEditUploadDetails(uploadDetails);
      handleFilePickOption(uploadDetails);
    }
  };
  return (
    <ScrollView>
      <View style={[web ? { paddingHorizontal: 10 } : {}]}>
        <>
          <>
            <CustomText
              style={{ fontSize: 20, textAlign: "center" }}
              bold={true}
            >
              {documentUploadFlag["headerText"]
                ? documentUploadFlag["headerText"]
                : "Upload Your Documents Here"}
            </CustomText>
            <Separator />

            {errorMessage["text"] !== "" && (
              <CustomText>{errorMessage["text"]}</CustomText>
            )}

            <View style={style.container}>
              <View style={style.tabs}>
                {renderTab("Required Documents", 0)}
                {renderTab(" Uploaded", 1)}
              </View>
              <View style={style.tabContent}>
                {modObjDoc.length > 0 ? (
                  <DropZone activeTab={activeTab} />
                ) : (
                  <Spinner />
                )}
              </View>
            </View>
          </>

          {!web && (
            <DrawerView
              bodyName={android ? "android" : "DocumentUpload"}
              isShow={drawerDetails["isShow"]}
              From={
                android && !editDetails["isVisible"] ? "pickFileOption" : ""
              }
              body={
                editDetails["isVisible"]
                  ? GetEditScreen({ iUploadDetails: null })
                  : drawerDetails["body"]
              }
              onClose={() => {
                if (drawerDetails["onClose"] === "CustomClose") {
                  if ((acceptedFiles || []).length) {
                    handleCancelConfirmation();
                  } else {
                    setDrawerDetails({
                      isShow: false,
                      body: <></>,
                      onClose: () => {},
                    });
                  }
                } else {
                  drawerDetails["onClose"]();
                }
              }}
            />
          )}
        </>
        {web && (
          <div
            id="buttonReloadDoc"
            style={{
              display: "flex",
              width: web ? "fit-content" : "auto",
              alignContent: "flex-end",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Button
              onPress={() => {
                handleDirectAdditionalUpload();
              }}
              title={
                <>
                  <CustomText
                    style={[
                      {
                        fontSize: 12,
                        color: "#fff",
                        alignSelf: "center",
                        flex: 1,
                      },
                      web && { textAlign: "right" },
                    ]}
                  >
                    Upload Additional documents
                  </CustomText>
                </>
              }
            />
            {isAdditionalUploading && (
              <View style={{ marginLeft: 8 }}>
                <Spinner text=" " />
              </View>
            )}
          </div>
        )}
      </View>
    </ScrollView>
  );
};

const style = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  tabs: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    // justifyContent: "center",
    marginBottom: 10,
  },
  tab: {
    padding: 10,
    borderBottomWidth: 2,
    borderBottomColor: "transparent",
    minWidth: "50%",
    textAlign: "center",
    justifyContent: "center",
    flexDirection: "row",
    alignItems: "center",
  },
  activeTab: {
    borderBottomColor: "black",
  },
  tabText: {
    fontSize: 12,
    marginRight: 5,
  },
  tabContent: {
    flex: 1,
    justifyContent: "center",
    //alignItems: "center",
  },

  dropContainer: {
    minHeight: 45,
    borderRadius: 5,
    paddingHorizontal: 10,
    paddingVertical: 5,
    width: "100%",
  },
  optionContainer: [
    {
      backgroundColor: "#f2f5f8",
      borderRadius: 18,
      paddingVertical: web ? 6 : 3,
      paddingHorizontal: web ? 12 : 0,
      borderColor: "#606060",
      borderWidth: 1,
      marginRight: 5,
      marginTop: 10,
      flexDirection: "row",
    },
    !web && { width: 70 },
  ],
  optionText: {
    fontSize: 13,
    color: "#787878",
    width: "100%",
    textAlign: "center",
    flex: 1,
    flexShrink: 1,
    paddingHorizontal: 15,
    paddingVertical: 2,
  },
  buttonContainer: {
    backgroundColor: "rgb(44, 134, 209)",
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginLeft: 8,
    borderRadius: 3,
  },
  buttonText: { color: "#fff", fontSize: 16 },
});
export default DocumentUpload;
